import { apolloClient } from '@/services/apollo-client'
import { ADD_TAGS, TAG_LIST, DELETE_TAGS, EDIT_TAGS, UPDATE_TAGS } from '@/graphql/tags/TAG'
export const tagsAPI = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: ADD_TAGS,
                variables: form
            })
            resolve(res.data.addSearchTags)
        } catch (e) {
            reject(e)
        }
    })
}

export const allTagsAPI = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: TAG_LIST,
                variables: form
            })
            resolve(res.data.getAllSearchTags)
        } catch (e) {
            reject(e)
        }
    })
}

export const deleteTags = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: DELETE_TAGS,
                variables: form
            })
            resolve(res.data.deleteSearchTags)
        } catch (e) {
            reject(e)
        }
    })
}
export const editTags = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: EDIT_TAGS,
                variables: form
            })
            resolve(res.data.getSearchTags)
        } catch (e) {
            reject(e)
        }
    })
}
export const updateTags = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: UPDATE_TAGS,
                variables: form
            })
            resolve(res.data.updateSearchTags)
        } catch (e) {
            reject(e)
        }
    })
}